/**
 * theme.js — global JavaScript entry point.
 *
 * Loaded with `defer` from `layout/theme.liquid`, so it runs after the
 * HTML document is parsed but before `DOMContentLoaded` fires.
 *
 * Intentionally empty for the Epic 1 foundation ticket. Per-component
 * behaviour belongs in `{% javascript %}` blocks inside sections /
 * blocks / snippets; only cross-cutting concerns that need to coordinate
 * across the page belong here.
 */

(function () {
  'use strict';

  if (window.console && typeof window.console.debug === 'function') {
    window.console.debug('theme ready');
  }
})();
